// extracted by mini-css-extract-plugin
export default {"errorMessage":"ErrorResponse_errorMessage__frUP3"};